export default __webpack_public_path__ + "static/media/Mask Group 140.0029f35d.svg";